import React, { useEffect } from 'react';

const LEGACY_QUOTE_SUPPORT_URL =
  'https://opendoorvalet.com/contact?topic=event-quote-link';

/**
 * Retired UUID-based event quote surface.
 *
 * A public event UUID is not an acceptance capability. Do not resolve it through
 * an anonymous events lookup or forward it to the website. Current customer
 * links are issued as https://opendoorvalet.com/accept-quote/:acceptanceToken.
 */
export default function LegacyEventQuoteLinkRedirect() {
  useEffect(() => {
    window.location.replace(LEGACY_QUOTE_SUPPORT_URL);
  }, []);

  return (
    <main className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="max-w-md text-center" role="status">
        <h1 className="text-2xl font-semibold mb-3">This event link has moved</h1>
        <p className="text-gray-300 mb-6">
          We are taking you to Open Door Valet so our events team can provide a
          fresh, secure quote link.
        </p>
        <a
          href={LEGACY_QUOTE_SUPPORT_URL}
          rel="noreferrer"
          className="inline-flex rounded-lg bg-[#AEA36D] px-5 py-3 font-semibold text-black"
        >
          Continue to Open Door Valet
        </a>
      </div>
    </main>
  );
}
